import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyBreak = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – Break, Continue & Pass</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this tutorial, we will learn about the break, continue
                    and pass statements in Python. These statements are also
                    known as loop control statements and can alter the normal
                    flow of a loop.
                  </p>
                </div>
                <br />
                <br />

                <h1 className="py_h1">Python Break Statement</h1>
                <p>
                  Suppose you have an assignment to find a specific number in a
                  given range. When your code finds that number, you want to
                  exit from the loop, instead of continuing till the end. To
                  exit from the loop you have to use break keyword in your
                  program.
                </p>
                <br />
                <br />
                <p>
                  You can use break keyword in a while or for loop in Python.
                  Whenever a break keyword is found in code, it immediately
                  exits from that block.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example 1: Example of a break statement in Python.</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     # It will print only 1 2
                     n=0
                     while n<=10:
                         n=n+1
                         if n==3:
                             break
                         print(n)
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python Continue Statement</h1>

                <hr style={{ color: "white" }} />
                <p>
                  Like a break keyword, a continue statement is also used within
                  loops. Whenever a continue statement is found in code, control
                  moves to the beginning of the loop, skip the current iteration
                  and start the next iteration
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>
                      Example 2: Example of a continue statement in Python.
                    </h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #It will print 1 2 4 5 without 3
                     n=0
                     while n<5:
                         n=n+1
                         if n==3:
                             continue
                         print(n)
                       `}
                    </code>
                  </pre>

                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     numbers=[11,22,33,44,55,66,77]
                     sum=0
                     for n in numbers:
                         sum+=n
                     print("Total :",sum)
                      
                     #the variable n takes the value from the List numbers one by one and calculate the sum until the last value
                       `}
                    </code>
                  </pre>
                </div>

                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Pass Statement in Python</h1>

                <hr style={{ color: "white" }} />
                <p>
                  In Python, the pass keyword is used for nothing. It means when
                  you want to execute nothing as code you can write pass in
                  loop, function or if as a statement. The pass statement is
                  generally ignored by the Python interpreter and can act as a
                  null statement.
                </p>

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example 3: Example of the pass keyword in Python.</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #print odd numbers only
                     for i in range(1,10):
                         if i%2==0:
                             pass
                         else:
                             print(i)
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
